module.exports = __webpack_public_path__ + "static/media/img_29tv03.e6f0eed4.jpg";